import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class StudySelectorDropDown extends Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.defaultSelectedOption !== nextProps.defaultSelectedOption) {
      this.dropdown.value = nextProps.defaultSelectedOption;
    }
  }

  render() {
    return (
      <div
        className="row expanded"
        onChange={e =>
          this.props.handleWeightTypeChange(Number(e.target.value))
        }
      >
        <select
          defaultValue={this.props.defaultSelectedOption}
          ref={node => (this.dropdown = node)}
        >
          <option value={1}>Population</option>
          <option value={2}>Household</option>
          <option value={Number(this.props.customWeightsOption.split(',')[0])}>
            {this.props.customWeightsOption}
          </option>
        </select>
      </div>
    );
  }
}

StudySelectorDropDown.propTypes = {
  customWeightsOption: PropTypes.string,
  handleWeightTypeChange: PropTypes.func,
  defaultSelectedOption: PropTypes.number,
};
